// Context and hook for the artifact drawer, kept out of the component file.
//
// Vite's fast refresh only preserves state for modules that export components
// and nothing else, so a file exporting both <ArtifactDrawer /> and
// useArtifactDrawer() forces a full reload on every edit.

import { createContext, useContext } from "react";

import type { Artifact } from "@/types/eryndal";

export interface ArtifactDrawerValue {
  artifacts: Artifact[];
  /** Pages call this to publish the artifacts currently in scope. */
  setArtifacts: (next: Artifact[]) => void;
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const ArtifactDrawerContext = createContext<ArtifactDrawerValue | null>(null);

export function useArtifactDrawer(): ArtifactDrawerValue {
  const ctx = useContext(ArtifactDrawerContext);
  if (!ctx) {
    throw new Error("useArtifactDrawer must be used inside <ArtifactDrawerProvider>");
  }
  return ctx;
}
